module.exports = "/_next/static/images/TeamPlan-sm-5e59142e9b025b082cf1e568ee8d0e82.webp";